import { useQuery } from '@tanstack/react-query';

import SponsorService from '@/services/SponsorService';
import { ROUTE_QUERY_GC_TIME, ROUTE_QUERY_STALE_TIME, keepPreviousQueryData } from '@/hooks/common/queryDefaults';
import QUERY_KEYS from '@/hooks/common/queryKeys';
import { useEntityById } from '@/hooks/common/useEntityById';

const EMPTY_SPONSOR_RESPONSE = {
    data: [],
    total: 0,
    current_page: 1,
    per_page: 10,
};

export const useSponsors = (filter) => {
    return useQuery({
        queryKey: QUERY_KEYS.sponsorsTable(filter),
        queryFn: () => SponsorService.getMapAll(filter).then((response) => response?.data ?? EMPTY_SPONSOR_RESPONSE),
        staleTime: ROUTE_QUERY_STALE_TIME,
        gcTime: ROUTE_QUERY_GC_TIME,
        placeholderData: keepPreviousQueryData,
    });
};

export const useSponsorById = (id) => {
    return useEntityById({
        storeKey: 'sponsors',
        entityId: id,
        queryKey: ['sponsor', id],
        queryFn: (sponsorId) => SponsorService.getId(sponsorId).then((r) => r?.data ?? null),
    });
};

